import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from 'components/atoms/input-duration';
import { BudgetedHoursCalculationMode } from 'data/templates/projects';
import { useBudgetHourFieldsForActiveTemplate } from './use-bugdet-hours-field';
import { useEstimatedBudgetHours } from './use-estimated-bugdet-hours';

interface Result {
  tooltip: ReactNode;
  text: ReactNode;
}
export const useBudgetedHoursConfigText = (): Result => {
  const { budgetedHoursConfig } = useBudgetHourFieldsForActiveTemplate();
  const { hasDynamicConditions, estimatedHoursAsText } =
    useEstimatedBudgetHours();
  const tooltip =
    budgetedHoursConfig != null ? (
      budgetedHoursConfig.mode === BudgetedHoursCalculationMode.Manual ? (
        <FormattedMessage
          id="templates.budget_hours.tooltip"
          values={{ hours: format('hh', budgetedHoursConfig.value) }}
        />
      ) : hasDynamicConditions ? (
        <FormattedMessage
          id="templates.budget_hours.options.automatic.hint"
          values={{
            hours: estimatedHoursAsText,
            strong: (chunks) => <strong>{chunks}</strong>,
            br: () => '',
          }}
        />
      ) : (
        <FormattedMessage
          id="templates.budget_hours.tooltip"
          values={{ hours: estimatedHoursAsText }}
        />
      )
    ) : null;
  const text =
    budgetedHoursConfig != null
      ? budgetedHoursConfig.mode === BudgetedHoursCalculationMode.Manual
        ? format('hh', budgetedHoursConfig.value)
        : estimatedHoursAsText
      : null;

  return {
    tooltip,
    text,
  };
};
